import { faEnvelopeOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useEffect, useState } from "react";
import { nama_pasangan } from "../../Constants/global";
// Asumsikan hiasan1 dan dot sudah diubah ke webp jika ada
import hiasan1 from "../../Img/hiasan-3.webp";

// Import sparkle
import dot1 from "../../Img/dot1.webp";
import dot2 from "../../Img/dot2.webp";
import dot3 from "../../Img/dot3.webp";

// Import gambar flower
import flowerKanan from "../../Img/flower.webp";
import flowerKiri from "../../Img/flower2.webp";

// Import background kiri (bg3) dan kanan (bg4)
import bgKiri from "../../Img/bg3.webp";
import bgKanan from "../../Img/bg4.webp";

export default function Cover({ transformUp, onClick }) {
  const [startBunga, setStartBunga] = useState(false);

  // 1. STATE UNTUK NAMA TAMU
  const [namaTamu, setNamaTamu] = useState("Tamu Undangan");

  const sparkles = useMemo(() => {
    const starImages = [dot1, dot2, dot3];
    return [...Array(35)].map(() => {
      const selectedImage =
        starImages[Math.floor(Math.random() * starImages.length)];
      const size =
        selectedImage === dot2 ? Math.random() * 3 + 3 : Math.random() * 6 + 12;
      return {
        top: Math.random() * 100,
        left: Math.random() * 100,
        size: size,
        image: selectedImage,
        duration: Math.random() * 3 + 2,
        delay: Math.random() * 5,
      };
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setStartBunga(true), 500);
    return () => clearTimeout(timer);
  }, []);

  // 2. FUNGSI MENANGKAP NAMA DARI LINK (URL)
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const tamuDariLink = searchParams.get("to");

    if (tamuDariLink) {
      setNamaTamu(tamuDariLink);
    }
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes heartbeat {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }

          @keyframes fly-in {
            0% { opacity: 0; transform: translateY(40px); }
            100% { opacity: 1; transform: translateY(0); }
          }

          @keyframes flower-reveal-left {
            0% { opacity: 0; transform: translate(-60px, 60px) scale(0.8); }
            100% { opacity: 1; transform: translate(0, 0) scale(1); }
          }

          @keyframes flower-reveal-right {
            0% { opacity: 0; transform: translate(60px, 60px) scale(0.8); }
            100% { opacity: 1; transform: translate(0, 0) scale(1); }
          }

          @keyframes flower-sway {
            0%, 100% { transform: rotate(-3deg); }
            50% { transform: rotate(3deg); }
          }

          @keyframes sparkle-twist {
            0%, 100% { opacity: 0; transform: scale(0.7) rotate(0deg); }
            50% { opacity: 0.6; transform: scale(1.1) rotate(20deg); }
          }

          .fly-in { animation: fly-in 1s ease-out forwards; }

          .wedding-title {
            font-family: 'Serif', 'Georgia', serif;
            letter-spacing: 5px;
            text-transform: uppercase;
            font-size: 0.75rem;
            color: #ffffff;
            margin-bottom: 0.5rem;
          }

          .text-gradient-gold {
            background: linear-gradient(to right, #bf953f, #fcf6ba, #b38728, #fcf6ba, #bf953f);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            text-fill-color: transparent;
            display: inline-block;
          }

          .btn-gradient-gold {
            background: linear-gradient(45deg, #bf953f 0%, #fcf6ba 45%, #b38728 100%);
            border: 1px solid #aa771c;
            color: #5d4037 !important;
            transition: all 0.3s ease;
          }

          /* 👇 PERBAIKAN: pointer-events diatur agar setelah tertutup, pintu ini "mati" 👇 */
          .gate-side {
            position: fixed;
            top: 0;
            height: 100vh; /* Pastikan menggunakan vh agar fit layar */
            width: 51%; 
            background-size: cover;
            transition: transform 1.2s cubic-bezier(0.7, 0, 0.3, 1), opacity 1s, pointer-events 0s 1.2s;
            z-index: 80; /* Dinaikkan z-indexnya agar aman dari konten lain di belakang */
            overflow: hidden;
          }

          .sparkle {
            position: absolute;
            pointer-events: none;
            animation: sparkle-twist infinite ease-in-out;
          }
        `}
      </style>

      {/* --- PINTU KIRI --- */}
      <div
        className="gate-side left-0"
        style={{
          backgroundImage: `url(${bgKiri})`,
          backgroundPosition: "right center",
          transform: transformUp ? "translateX(-100%)" : "translateX(0)",
          pointerEvents: transformUp ? "none" : "auto", // Mati jika terbuka
          opacity: transformUp ? 0 : 1, // Perlahan menghilang saat terbuka agar bersih dari layar
        }}
      >
        {sparkles
          .filter((s) => s.left < 50)
          .map((star, i) => (
            <img
              key={`L-${i}`}
              src={star.image}
              alt="sparkle"
              className="sparkle"
              style={{
                top: `${star.top}%`,
                left: `${star.left * 2}%`,
                width: `${star.size}px`,
                animationDuration: `${star.duration}s`,
                animationDelay: `${star.delay}s`,
              }}
            />
          ))}

        <div
          className={`absolute bottom-[-50px] left-[-50px] w-full max-w-[500px] pointer-events-none ${startBunga ? "opacity-100" : "opacity-0"}`}
          style={{
            animation: startBunga
              ? "flower-reveal-left 1.8s ease-out forwards"
              : "none",
            transformOrigin: "bottom left",
          }}
        >
          <img
            src={flowerKiri}
            className="w-full h-auto"
            style={{
              animation: "flower-sway 7s ease-in-out infinite alternate",
            }}
            alt="flower left"
          />
        </div>
      </div>

      {/* --- PINTU KANAN --- */}
      <div
        className="gate-side right-0"
        style={{
          backgroundImage: `url(${bgKanan})`,
          backgroundPosition: "left center",
          transform: transformUp ? "translateX(100%)" : "translateX(0)",
          pointerEvents: transformUp ? "none" : "auto", // Mati jika terbuka
          opacity: transformUp ? 0 : 1, // Perlahan menghilang saat terbuka agar bersih dari layar
        }}
      >
        {sparkles
          .filter((s) => s.left >= 50)
          .map((star, i) => (
            <img
              key={`R-${i}`}
              src={star.image}
              alt="sparkle"
              className="sparkle"
              style={{
                top: `${star.top}%`,
                left: `${(star.left - 50) * 2}%`,
                width: `${star.size}px`,
                animationDuration: `${star.duration}s`,
                animationDelay: `${star.delay}s`,
              }}
            />
          ))}

        <div
          className={`absolute bottom-[-50px] right-[-50px] w-full max-w-[500px] pointer-events-none ${startBunga ? "opacity-100" : "opacity-0"}`}
          style={{
            animation: startBunga
              ? "flower-reveal-right 1.8s ease-out forwards"
              : "none",
            animationDelay: "0.3s",
            transformOrigin: "bottom right",
          }}
        >
          <img
            src={flowerKanan}
            className="w-full h-auto"
            style={{
              animation: "flower-sway 7s ease-in-out infinite alternate",
            }}
            alt="flower right"
          />
        </div>
      </div>

      {/* --- KONTEN TENGAH --- */}
      {/* 👇 PERBAIKAN: Jika undangan terbuka, div tengah ini dihilangkan (none) agar tidak memakan z-index 👇 */}
      <div
        className="fixed inset-0 z-[85] flex items-center justify-center pointer-events-none"
        style={{
          transition: "all 0.8s ease",
          opacity: transformUp ? 0 : 1,
          transform: transformUp ? "scale(1.1)" : "scale(1)",
          visibility: transformUp ? "hidden" : "visible",
        }}
      >
        <div className="text-center fly-in px-4 pointer-events-auto flex flex-col items-center justify-center w-full max-w-2xl">
          <div className="flex justify-center mb-6">
            <img
              src={hiasan1}
              alt="hiasan1"
              className="w-[80px] md:w-[100px]"
            />
          </div>

          <div className="wedding-title">The Wedding Of</div>

          <div className="w-full block mb-2">
            <h1 className="text-gradient-gold custom-font-2 font-semibold text-5xl md:text-6xl p-2 drop-shadow-md">
              {nama_pasangan}
            </h1>
          </div>

          <div className="w-full flex justify-center mt-6 mb-8">
            <div className="bg-black/40 backdrop-blur-sm border border-[#d4af37]/40 rounded-2xl py-5 px-8 max-w-sm w-full shadow-2xl">
              <div className="text-[#ffffff] font-medium text-[10px] md:text-xs mb-2 opacity-90 uppercase tracking-widest">
                Kepada Yth. Bapak/Ibu/Saudara/i
              </div>
              <div className="text-[#fcf6ba] font-bold text-xl md:text-2xl font-serif">
                {namaTamu}
              </div>
            </div>
          </div>

          <p className="text-[#ffffff] text-xs md:text-base mb-8 max-w-md mx-auto opacity-90 font-medium leading-relaxed drop-shadow-lg">
            Tanpa Mengurangi Rasa Hormat, Kami Mengundang Anda Untuk Berhadir Di
            Acara Ngunduh Mantu kami.
          </p>

          <button
            type="button"
            onClick={onClick}
            className="btn-gradient-gold text-sm md:text-md font-bold rounded-xl px-10 py-3.5 shadow-xl cursor-pointer"
            style={{ animation: "heartbeat 1.5s ease-in-out infinite" }}
          >
            <FontAwesomeIcon icon={faEnvelopeOpen} className="mr-2" /> Buka
            Undangan
          </button>
        </div>
      </div>
    </>
  );
}
